import { useJobServiceFetch } from '@src/fetchers';

interface DraftEvent {
  step: string;
  variant?: string;
  repostJobId?: string;
}

export function useTrackDraftEvent() {
  const { fetch } = useJobServiceFetch();
  return ({ step, repostJobId, variant }: DraftEvent) => {
    fetch('caja-draft-events', {
      body: JSON.stringify({
        step,
        variant,
        repostJobId
      }),
      method: 'POST',
      credentials: 'include'
    });
  };
}
